export default "assets/images/icons/success-6cb4e499.svg";